const SEEL_DISCOUNT_ATTRIBUTE = '_seel_wfp_discount_info';
const SEEL_DISCOUNT_VALUE = JSON.stringify({ promotion_type: 'over_500_free', merchant_discount: 100 });
let seelCartSync = Promise.resolve();

window.syncSeelDiscount = function () {
  const sync = seelCartSync.catch(() => {}).then(async () => {
    const root = window.Shopify.routes.root;
    const cartResponse = await fetch(`${root}cart.js`);
    if (!cartResponse.ok) throw new Error('读取购物车失败');

    const cart = await cartResponse.json();
    const value = cart.total_price > 50000 ? SEEL_DISCOUNT_VALUE : '';
    if ((cart.attributes[SEEL_DISCOUNT_ATTRIBUTE] || '') === value) return;

    const updateResponse = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [SEEL_DISCOUNT_ATTRIBUTE]: value } }),
    });
    if (!updateResponse.ok) throw new Error('更新 Seel 购物车属性失败');
  });

  seelCartSync = sync;
  return sync;
};

subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
  window.syncSeelDiscount().catch(console.error);
});

document.addEventListener('DOMContentLoaded', () => {
  window.syncSeelDiscount().catch(console.error);
});

const seelResumingForms = new WeakSet();
document.addEventListener('submit', (event) => {
  if (event.submitter?.name !== 'checkout') return;
  if (seelResumingForms.delete(event.target)) return;

  event.preventDefault();
  const form = event.target;
  const submitter = event.submitter;
  window.syncSeelDiscount()
    .catch(console.error)
    .finally(() => {
      seelResumingForms.add(form);
      form.requestSubmit(submitter);
    });
}, true);
